import { render, staticRenderFns } from "./ExternalApproval.vue?vue&type=template&id=94be1b72"
import script from "./ExternalApproval.vue?vue&type=script&lang=js"
export * from "./ExternalApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports